/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import PageTitle from '../../../client/js/components/PageTitle'
import { AuthContext } from '../components/AuthProvider'
import { getSignInLink } from '../lib/authLinks'
import { Card, Group, Loader, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../client/js/components/AnchorLink'
import Page from '../../../client/js/components/Page'

function SignOutPage () {
  const intl = useIntl()
  const auth = useContext(AuthContext)
  const { signOut } = auth

  useEffect(() => {
    signOut()
  }, [signOut])

  return (
    <Page>
      <Card shadow="sm" p="xl">
        {!auth.signedIn && !auth.signingOut
          ? <Group gap="xl">
            <FontAwesomeIcon
              fixedWidth
              icon={faSignOutAlt}
              size="4x"
            />
            <Stack gap="xs">
              <PageTitle
                size="h2"
                title={intl.formatMessage({
                  id: 'signed_out',
                  defaultMessage: 'Déconnecté'
                })}
              />
              <FormattedMessage
                id="signed_out_message"
                defaultMessage="Vous êtes désormais déconnecté."
              />
              <AnchorLink to={getSignInLink()}>
                <FormattedMessage
                  id="reconnect_link"
                  defaultMessage="Cliquez-ici pour vous reconnecter"
                />
              </AnchorLink>
            </Stack>
          </Group>
          : null}

        {auth.signingOut
          ? <Group gap="xl">
            <Loader size="lg" />
            <Stack gap="xs">
              <PageTitle
                size="h2"
                title={intl.formatMessage({
                  id: 'signing_out_in_progress',
                  defaultMessage: 'Déconnexion en cours...'
                })}
              />
              <Text>
                <FormattedMessage
                  id="signing_out_message"
                  defaultMessage="Veuillez attendre la confirmation de déconnexion."
                />
              </Text>
            </Stack>
          </Group>
          : null}
      </Card>
    </Page>
  )
}

export default SignOutPage
